import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { useRef } from 'react'

// Components
import Icon from '@/assets/icons'
import Button from '@/components/common/livemallclub/Button'
import Popup from '@/components/common/Popup'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type AgeLimitPopupProps = {
  isOpen: boolean
  handleClose: () => void
}

const AgeLimitPopup = ({ isOpen, handleClose }: AgeLimitPopupProps) => {
  const { t } = useTranslation()
  const popupRef = useRef<HTMLDivElement>(null)

  return (
    <Popup
      ref={popupRef}
      title={t('Age_Limit_Popup_Title')}
      canClose={false}
      hasCancel={false}
      hasConfirm={false}
      icon={
        <div className={cx('age-limit-popup__icon')}>
          <Icon.Disabled />
        </div>
      }
      isOpen={isOpen}
    >
      <div className={cx('age-limit-popup')}>
        <p className={cx('age-limit-popup__description')}>{t('Age_Limit_Popup_Description')}</p>
        <Button onClick={handleClose} theme='pink'>
          {t('Age_Limit_Popup_Button')}
        </Button>
      </div>
    </Popup>
  )
}

export default AgeLimitPopup
